import { callAgroApi } from '@services/agroapi';
export const withActivities = self => ({
  actions: {
    deleteActivity(activityId: string) {
      return callAgroApi(`/activities/${activityId}`, 'DELETE');
    }
  }
});